import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";

import H1 from "../h1/component";
import InputText from "../input-text";
import InputTextarea from "../input-textarea";
import Search from "../search";
import Button from "../button";
import CallIcon from "./images/call.svg";
import MailIcon from "./images/mail.svg";
import ContactUsThankyouModal from "../contact-us-thankyou-modal/component";
import { API_SOURCE, HELPLINE_NUMBER_AU, SUPPORT_EMAIL } from "../../../constants/app-constants";
import nameValidator from "../../../utils/validators/name-validator";
import { validateEmail } from "../../../utils/validators/email-validator";
import { STATIC_META_CONSTANTS } from "../../../constants/meta-static-page";
import StaticPageMeta from "../meta-tags/static-meta";
import { contactUsFormMetaData, contactUsFormQuerySources } from "../../../utils/helpers/contactus-form-metadata";
import { mobileNumberValidatorAU } from "../../../utils/validators/mobile-number-validator";
import { getDeviceType } from "../../../utils/helpers/get-device-type";

const AccessibleSearch = (props) => <Search {...props} tabAccessibility={true} />;
const CONTACT_US_ENQUIRY_REASON = [
    { label: "I am interested in buying a car.", value: "I am interested in buying a car." },
    { label: "I am interested in selling a car.", value: "I am interested in selling a car." },
    { label: "I am waiting for my car delivery.", value: "I am waiting for my car delivery." },
    { label: "I have received my car and need help.", value: "I have received my car and need help." },
    { label: "I have a warranty claim.", value: "I have a warranty claim." },
    { label: "Other", value: "Other" }
];

const initialFormValue = {
    firstName: "",
    lastName: "",
    email: "",
    reasonForEnquiry: "",
    additionalDetails: ""
};

const ContactUsInfo = ({
    submitContactUsConnect,
    trackEvents,
    AU_EVENTS = {}
}) => {
    const [formInput, setFormInput] = useState(initialFormValue);
    const [isLoading, setLoading] = useState(false);
    const [showThankYouModal, setShowThankYouModal] = useState(false);
    //const [captchaResponse, setCaptchaToken] = useState(null);

    const trackButtonEvent = (eventName) => {
        trackEvents(AU_EVENTS.CONTACT_US_BUTTON, { eventLabel: `options ${eventName}` });
    };

    const handleFormInput = (id, event) => {
        const value = event.target ? event.target.value : event.value;
        setFormInput({ ...formInput, [id]: value });
    };

    /* DIFFCHECK */
    const resetForm = () => {
        setFormInput(initialFormValue);
        //if (window.grecaptcha) {
        //    window.grecaptcha.reset();
        //}
    };

    const onSubmit = async () => {
        //if (window.grecaptcha) {
        try {
            setLoading(true);
            await submitContactUsConnect({
                ...formInput,
                ...contactUsFormMetaData({
                    querySource: contactUsFormQuerySources.contactUsPage
                })
            });
            resetForm();
            setLoading(false);
            setShowThankYouModal(true);
            trackButtonEvent("Submit");
        } catch (error) {
            setLoading(false);
            setShowThankYouModal(false);
        }
        //}
    };

    const onCloseThankYouModal = () => {
        trackButtonEvent("acknowledgement_pop_up_close");
        setShowThankYouModal(false);
    };

    const trackInputEvent = (eventName) => {
        trackEvents(AU_EVENTS.CONTACT_US_INPUT, { eventLabel: `options ${eventName}` });
    };

    //const onCaptchChange = (token) => {
    //    setCaptchaToken(token);
    //};

    const formData = [
        {
            component: InputText,
            id: "firstName",
            text: "First Name",
            validator: nameValidator,
            eventLabel: "firstName",
            required: true,
            errorMessage: "Please enter a valid first name",
            isVisible: true
        },
        {
            component: InputText,
            id: "lastName",
            text: "Last Name",
            // validator: nameValidator,
            eventLabel: "lastName",
            isVisible: true
            // errorMessage: "Please enter last name"
        },
        {
            component: InputText,
            id: "email",
            text: "Email",
            validator: validateEmail,
            eventLabel: "firstName",
            errorMessage: "Please enter a valid email",
            isVisible: true
        },
        {
            component: AccessibleSearch,
            id: "reasonForEnquiry",
            placeholder: "Reason for Enquiry",
            data: CONTACT_US_ENQUIRY_REASON,
            isSearchable: false,
            noOptionsMessage: () => "Reason for Enquiry",
            isVisible: getDeviceType() === API_SOURCE.M_SITE
            // value: ""

        },
        {

            component: InputText,
            placeholder: "e.g. 04XX XXX XXX",
            showPlaceHolderAsLabel: false,
            id: "phoneNumber",
            text: "e.g. 04XX XXX XXX",
            validator: mobileNumberValidatorAU,
            eventLabel: "phoneNumber",
            required: true,
            errorMessage: "Enter your phone number",
            label: "Phone no.",
            isVisible: getDeviceType() === API_SOURCE.WEB_APP

        },
        {
            component: InputTextarea,
            id: "additionalDetails",
            label: "Please provide additional details here",
            placeholder: "Please provide additional details here",
            // validator: validateEmail,
            eventLabel: "Query",
            isVisible: true
        }

    ];

    //const isDisabled = !captchaResponse || !(nameValidator(formInput.firstName) && validateEmail(formInput.email) && formInput.additionalDetails && formInput.reasonForEnquiry);
    const isDisabled = !(nameValidator(formInput.firstName) && validateEmail(formInput.email) && formInput.additionalDetails && formInput[getDeviceType() === API_SOURCE.M_SITE ? "reasonForEnquiry" : "phoneNumber"]);

    return (
        <React.Fragment>
            <StaticPageMeta type={STATIC_META_CONSTANTS.CONTACTUS} />
            <div styleName={"styles.contactWrapper"}>
                <H1 text="Welcome to Cars24 Australia" />
                <div styleName={"styles.formWrapper"}>
                    {formData.map((item) => (
                        item.isVisible &&
                        <div styleName={"styles.inputField"} key={item.id}>
                            <item.component
                                value={
                                    // eslint-disable-next-line no-nested-ternary
                                    item.id === "reasonForEnquiry" ?
                                        formInput[item.id] ? { value: formInput[item.id], label: formInput[item.id] } : null :
                                        formInput[item.id]
                                }
                                rest={item.id === "additionalDetails" && {value: formInput[item.id]}}
                                placeholder={item.placeholder ? item.placeholder : ""}
                                onChange={(event) => handleFormInput(item.id, event)}
                                onBlurCallback={() => trackInputEvent(item.eventLabel)}
                                {...item}
                            />
                        </div>)
                    )}
                    {/*<div styleName={"styles.inputField"}>

                        <LoadableCaptcha  fallback={<React.Fragment />}>
                            {({ default: ReCAPTCHA }) =>
                                (<ReCAPTCHA
                                    sitekey={process.env.GOOGLE_REPATCHA_SITE_KEY}
                                    onChange={onCaptchChange}
                                />
                                )}
                        </LoadableCaptcha>
                    </div>*/}
                    <Button disabled={isDisabled || isLoading} isLoading={isLoading} onClick={onSubmit} text="SUBMIT" />
                </div>
                <div styleName={"styles.contactBottom"}>
                    <p>Looking for a way to get in touch with the Cars24 Australia team? Here are your options:</p>
                    <p><span>Looking to buy a new car?</span><br />Our sales team is available to assist you Monday to Sunday - 8am to 8pm AEST</p>
                    <p><span>Are you an existing customer with a current reservation or delivery?</span><br />Our friendly Customer Service team is available to help you Monday to Friday - 8am - 6pm AEST and on Saturday - 9am - 5pm AEST</p>
                    <p><span>Looking to sell us your car?</span><br />We are available Monday to Friday - 8am to 5pm AEST to help you with your queries.</p>
                    <p><span>Change your account information?</span><br />Our team is here to assist you from Monday to Friday, 8 am to 6 pm AEST, and on Saturdays from 9 am to 5 pm AEST. Reach out to us for any inquiries regarding actions such as creating a new account, removing an existing account, or modifying account details.</p>
                    <p>You can contact our team on the following email ID or phone number.</p>
                    {/* <p>We are available 7 days a week, 8 am - 8 pm!</p> */}
                    <ul styleName={"styles.contactList"}>
                        <li>
                            <a onClick={() => { trackButtonEvent("email"); }} href={`mailto:${SUPPORT_EMAIL}`}>
                                <img src={MailIcon} alt="mail us" />
                                {SUPPORT_EMAIL}
                            </a>
                        </li>
                        <li>
                            <a onClick={() => { trackButtonEvent("call"); }} href={`tel:${HELPLINE_NUMBER_AU.value}`}>
                                <img src={CallIcon} alt="call us" />
                                {HELPLINE_NUMBER_AU.label}
                            </a>
                        </li>
                        <li>
                            <a onClick={() => { trackButtonEvent("call"); }} styleName={"styles.underlineLinkATag"} href={`mailto:media.au@cars24.com`}>
                                <span>For media enquiries, contact us at : </span><span styleName={"styles.underlineLink"}> media.au@cars24.com</span>
                            </a>
                        </li>
                    </ul>
                </div>
                {showThankYouModal && <ContactUsThankyouModal onClose={onCloseThankYouModal} />}
            </div>
        </React.Fragment>
    );
};

ContactUsInfo.propTypes = {
    submitContactUsConnect: PropTypes.func,
    AU_EVENTS: PropTypes.object,
    trackEvents: PropTypes.func
};

export default ContactUsInfo;
